import { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

import { isTma, WebApp } from 'shared/utils';

export const useBackButton = (path?: string, callback?: () => void) => {
	const navigate = useNavigate();
	const { pathname } = useLocation();

	const onButtonClick = () => {
		if (path) navigate(path);
		callback?.();
	};

	useEffect(() => {
		if (isTma && WebApp) {
			const backButton = WebApp.BackButton;

			if (!backButton.isVisible) {
				backButton.show();
			}
			backButton.offClick(onButtonClick);
			backButton.onClick(onButtonClick);
		}

		return () => {
			if (isTma && WebApp) {
				const backButton = WebApp.BackButton;

				backButton.offClick(onButtonClick);
				if (backButton.isVisible) {
					backButton.hide();
				}
			}
		};
	}, [pathname, navigate, path, callback]); // eslint-disable-line react-hooks/exhaustive-deps
};
